import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'dl-file-format-dialog',
  templateUrl: './file-format-dialog.component.html',
  styleUrls: ['./file-format-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileFormatDialogComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {}

}
